"use client";

import React from "react";
import { useAccountDeletionSuccessModal } from "@/components/hooks/settings/useAccountDeletion.hook";


import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import AccountDeletionIcon from "@/components/ui/icons/AccounDeletionIcon";

const AccountDeletionSuccessModal = () => {
  const { showSuccessModal, setShowSuccessModal, handleOkClick } = useAccountDeletionSuccessModal();

  return (
    <Dialog open={showSuccessModal} onOpenChange={setShowSuccessModal}>
      <DialogContent className="max-w-[440px]">
        <DialogHeader className="text-center">
          <AccountDeletionIcon />
          <DialogTitle className="text-2xl font-semibold text-center">
            We&apos;ve Just Received Your Request
          </DialogTitle>
          <DialogDescription className="text-base text-gray-600 text-center mt-4 space-y-6">
            <p>
              Your account has been queued for deletion and will be permanently deleted in 14 days.
            </p>
            <p>
              If you wish to cancel the deletion, just log in to your account and cancel the request.
            </p>
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center mt-4">
          <Button
            onClick={handleOkClick}
            className="w-full"
            data-testid="ok-got-it-button"
          >
            Ok, Got It
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AccountDeletionSuccessModal;

